export const upperCase = (string = '') => string.toUpperCase()
